import { render, staticRenderFns } from "./imgC.vue?vue&type=template&id=770748dc&scoped=true"
var script = {}
import style0 from "./imgC.vue?vue&type=style&index=0&id=770748dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770748dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770748dc')) {
      api.createRecord('770748dc', component.options)
    } else {
      api.reload('770748dc', component.options)
    }
    module.hot.accept("./imgC.vue?vue&type=template&id=770748dc&scoped=true", function () {
      api.rerender('770748dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgC.vue"
export default component.exports